import InfoGraphicChart from './infoGraphicChart.module';

export default class InfoGraphicChartPie extends InfoGraphicChart {
  constructor( node, data ) {
    super( node, data );
    window.addEventListener( 'resize', this.setResizeOptions.bind( this ));
  }

  setResizeOptions( resizeEvent ) {
    let height = Math.min( screen.width / 2, 217 );
    let options = {
      chart: {
        margin: 10,
        spacing: [ 0, 10, 0, 10 ],
        height: height * 1.2
      },
      plotOptions: {
        pie: {
          size: height,
          dataLabels: {
            enabled: false,
            crop: false,
            distance: 5,
            connectorPadding: 0
          },
          showInLegend: true
        }
      },
      legend: {
        shadow: false,
        squareSymbol: true,
        symbolHeight: 10,
        symbolWidth: 10,
        symbolRadius: 0,
        symbolPadding: 5,
        itemDistance: 10,
        itemStyle: {
          fontSize: '12px'
        },
        backgroundColor: 'none',
        enabled: true,
        layout: 'horizontal',
        floating: false,
        align: 'left',
        borderWidth: 0,
        verticalAlign: 'bottom',
        itemMarginBottom: 15,
        margin: 50,
        useHTML: true,
        x: 0,
        y: 0,
        labelFormatter: function() {
          let sliceIndex = this.x;
          let sliceName = this.series.chart.axes[ 0 ].categories[ sliceIndex ];
          return '<div class="highcharts__legend-description"><span>' + sliceName + '</span></div>';
        }
      }
    };

    if ( window.innerWidth >= 600 ) {
      let height = Math.min( screen.width * 0.45, 350 );
      options.chart = {
        margin: 20,
        spacing: [ 50, 20, 50, 20 ],
        height: height * 1.3
      };
      options.plotOptions.pie = {
        size: height,
        dataLabels: {
          enabled: true,
          distance: 30,
          connectorPadding: 15
        },
        showInLegend: false
      };
    }

    if ( window.innerWidth >= 1280 ) {
      let height = Math.min( screen.width * 0.50, 350 );
      options.chart = {
        margin: 20,
        spacing: [ 50, 20, 50, 20 ],
        height: height * 1.4
      };
      options.plotOptions.pie = {
        size: height,
        dataLabels: {
          enabled: true,
          distance: 50,
          connectorPadding: 20
        },
        showInLegend: false
      };
    }

    // fired by resize
    if ( resizeEvent ) {
      this.removeCircle();
      this.chart.update( options );
    } else {
      return options;
    }
  }

  removeCircle() {
    let oldCircle = this.chart.container.querySelector( '.chart-highchart__circle' );
    if ( oldCircle ) {
      oldCircle.parentNode.removeChild( oldCircle );
    }
  }

  drawCircle( initial = false ) {

    let chart = this.chart || this;

    this.removeCircle();

    // draw when chart has been rendered only
    // otherwise wrong size of the circle
    if ( !chart.hasRendered ) {
      return false;
    }

    let draw = () => {
      let chartContainer = chart.container;
      let pieContainer = chart.seriesGroup.element;
      let chartPos = chartContainer.getBoundingClientRect();
      let piePos = pieContainer.getBoundingClientRect();
      let padding = 15;

      if ( screen.width >= 768 ) {
        padding = 20;
      } else if ( screen.width >= 1024 ) {
        padding = 35;
      }

      let radius = piePos.height / 2;
      let x = piePos.left - chartPos.left + radius;
      let y = piePos.top - chartPos.top + radius;

      chart.renderer
        .circle( x, y, radius + padding )
        .attr({
          fill: 'rgba(255, 255, 255, 0.65)',
          class: 'chart-highchart__circle'
        })
        .add();
    };

    if ( initial ) {
      setTimeout( draw, 250 );
    } else {
      draw();
    }
  }

  copyLegend() {
    const legend = this.node.querySelector( 'div.highcharts-legend' );
    const legendColors = this.node.querySelector( 'g.highcharts-legend' );

    if ( legend ) {
      const cloneLegend = legend.cloneNode( true );
      const cloneColors = legendColors.cloneNode( true );
      const descriptions = cloneLegend.querySelectorAll( '.highcharts__legend-description' );
      const items = cloneLegend.querySelectorAll( '.highcharts-legend-item' );
      const colorItems = cloneColors.querySelectorAll( '.highcharts-legend-item' );
      const newLegend = document.createElement( 'div' );
      newLegend.classList.add( 'highcharts-legend--clone' );
      for ( let i = 0; i < items.length; i++ ) {
        let span = document.createElement( 'span' );
        span.classList.add( 'highcharts-legend--clone__square' );
        span.style.backgroundColor = colorItems[ i ].childNodes[ 0 ].getAttribute( 'fill' );
        descriptions[ i ].appendChild( span );
        items[ i ].classList.add( 'highcharts-legend-item--show' );
        items[ i ].style.cssText = '';
        items[ i ].childNodes[ 0 ].style.cssText = '';
        newLegend.appendChild( items[ i ]);
      }
      this.node.appendChild( newLegend );
    }
  }

  setOptions() {
    super.setOptions();

    let categories = this.options.xAxis.categories;
    let title = `
        <span class="highcharts-title__main">${this.options.xAxis.title.text}</span>
        <span class="highcharts-title__sub">${this.options.yAxis[ 0 ].title.text}</span>
    `;

    let initialLoad = true;

    // remove innerSize setting from alle series to use global config
    this.options.series.forEach( function( serie ) {
      delete serie.innerSize;
    });

    this.mergeObjects( this.options, {
      chart: {
        margin: 20,
        spacing: [ 50, 20, 50, 20 ],
        events: {
          redraw: this.drawCircle.bind( this, false )
        }
      },
      title: {
        text: title,
        useHTML: true
      },
      legend: {
        enabled: false
      },
      tooltip: {
        backgroundColor: 'transparent',
        borderWidth: 0,
        padding: 0,
        useHTML: true,
        formatter: function() {
          let sliceIndex = this.point.index;
          let sliceName = this.series.chart.axes[ 0 ].categories[ sliceIndex ];
          return `
            <div class="charts-highchart__tooltip">
                <span>${sliceName}</span>
                <br>
                <strong>${this.percentage.toFixed( 0 )} %</strong>
                <svg class="charts-highchart__tooltip-arrow" width="16" height="16" viewBox="0 0 100 100">
                    <polygon fill="white" points="0 0 100 0 50 65"></polygon>
                </svg>
            </div>
            `;
        }
      },
      plotOptions: {
        pie: {
          allowPointSelect: false,
          cursor: 'pointer',
          innerSize: '80%',
          borderWidth: 0,
          dataLabels: {

            className: 'charts-highchart__data-label',
            enabled: true,
            distance: 10,
            connectorColor: 'rgba(68, 68, 68, 0.5)',
            connectorShape: 'straight',
            connectorPadding: 10,
            softConnector: false,
            // alignTo: 'plotEdges', /* different behaviour in highcharts >= v7 */
            formatter: function() {
              return categories[ this.point.index ];
            }
          },
          showInLegend: true,
          animation: {
            duration: 500
          },
          events: {
            afterAnimate: () => {
              if ( initialLoad ) {
                this.drawCircle( true );
                this.copyLegend();
                initialLoad = false;
              }
            }
          },
          states: {
            hover: {
              brightness: 0,
              halo: {
                opacity: 1
              }
            }
          }
        }
      }
    });

    this.mergeObjects( this.options, this.setResizeOptions());
  }
}
